<div id="error" class="container">
  <div class="header-title">
    <mat-icon>sentiment_dissatisfied</mat-icon>
    <h6 class="title-large" i18n="@@Somethingwentwrong">
      {{ title | translate }}
    </h6>
    <app-button-extra *ngIf="!noButtons" (click)="close()" [type]="'icon'">
      <i class="ic-x-sm ic-cancel"></i>
    </app-button-extra>
  </div>
  <div class="content">
    <p i18n="@@Systemerror,pleasetryagaininafewminutes">
      {{ message | translate }}
    </p>
  </div>
  <div *ngIf="!noButtons" class="actions">
    <app-button-default
      (click)="close()"
      size="lg"
      type="dark"
      i18n="@@Close"
      >{{ "Close" | translate }}</app-button-default
    >
  </div>
</div>
